import { createFileRoute } from "@tanstack/react-router";

import ComingSoon from "../../../components/ComingSoon";

export const Route = createFileRoute("/_app/visas/")({
  component: Visas,
});

function Visas() {
  return <ComingSoon />;
}
